import { render } from "./SetModal.vue?vue&type=template&id=2e1debce&scoped=true"
import script from "./SetModal.vue?vue&type=script&lang=js"
export * from "./SetModal.vue?vue&type=script&lang=js"

import "./SetModal.vue?vue&type=style&index=0&id=2e1debce&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1debce"]])

export default __exports__